<template>
  <!-- <div></div> -->
  <aside class="aside-menu" >
    <b-tabs style="border-bottom: 1px solid #a4b7c1;">
      <b-tab title="<i class='icon-list'></i>">
        <Callout class="m-0 py-2 text-muted text-center bg-light text-uppercase">
          <small style="padding-right:10px;"><b>Book Marked</b></small>
            <b-button type="submit" size="sm" variant="outline-primary"
            style="background:white;min-width:20px;height:20px;padding:0 0;"
            @click="refreshBookMark">
              <i class="fa fa-refresh fa-sm" style="color:#20a8d8"></i>
            </b-button>
        </Callout>
        <hr class="transparent mx-3 my-0">
        <div v-for="historyData in formDataList">
          <div class="animated fadeIn">
            <Callout :variant="historyData.css" class="m-0 py-3">
              <div v-on:click="gotoForm(historyData)">
                <small><b>{{historyData.formData.campaignTitle}}</b></small>
                <br>
                <small><b>{{historyData.formData.simulationTitle}}</b></small>
              </div>
              <div style="padding-top:5px;">
                <i class="fa fa-line-chart fa-sm" v-if="historyData.view_cd == 'reachSimulation'">
                  <span style="font-size:11px;font-weight:600"> (VA)</span>
                </i>
                <i class="fa fa-line-chart fa-sm" v-if="historyData.view_cd == 'reachSimulationDA'">
                  <span style="font-size:11px;font-weight:600"> (DA)</span>
                </i>
                <i class="fa fa-money fa-sm" v-if="historyData.view_cd == 'budgetAllocation'">
                  <span style="font-size:11px;font-weight:600"> (VA)</span>
                </i>
                <small>&nbsp;&nbsp;{{historyData.std_dt}}&nbsp;&nbsp;</small>
                <span class="float-right">
                  <!-- <b-button type="submit" size="sm" variant="outline-danger btn-pill" @click="deleteBookMark(historyData)">
                    <i class="fa fa-times-circle fa-sm"></i>
                  </b-button> -->
                  <b-button type="submit" size="sm" variant="light" style="background-color:transparent" class="btn-pill" @click="deleteBookMark(historyData)">
                    <span style="font-size:12px;font-weight:900;">X</span>
                  </b-button>
                </span>
              </div>
            </Callout>
            <hr class="mx-3 my-0">
          </div>
        </div>
      </b-tab>
      <!-- <b-tab title="<i class='icon-speech'></i>">
        <div class="p-3">
          <div class="message">
            <div class="py-3 pb-5 mr-3 float-left">
              <div class="avatar">
                <img src="static/img/avatars/7.jpg" class="img-avatar" alt="admin@bootstrapmaster.com">
                <b-badge variant="success" class="avatar-status" ></b-badge>
              </div>
            </div>
            <div>
              <small class="text-muted">Lukasz Holeczek</small>
              <small class="text-muted float-right mt-1">1:52 PM</small>
            </div>
            <div class="text-truncate font-weight-bold">Lorem ipsum dolor esit amet</div>
            <small class="text-muted">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...</small>
          </div>
          <hr>
        </div>
      </b-tab> -->
      <b-tab title="<i class='icon-calculator'></i>">
        <div class="p-3">
          <div class="aside-options">
            <div class="clearfix mt-4" style="padding-bottom:10px;">
              <b>CPRP → CPM 변환</b>
            </div>
            <div>
              <b-row>
                <b-col sm="5" style="padding-right: 0px;">
                  <span class="wise-small-header wise-small-header2">CPRP</span>
                  <b-form-input style="background:#fff;" min=0 v-model="cprpStr" :formatter="format_cprpStr" type="text"></b-form-input>
                </b-col>
                <b-col sm="7">
                  <span class="wise-small-header wise-small-header2">타겟</span>
                  <div style="border: 1px solid #c2cfd6;"> <!-- 임시방편 .. -->
                    <select id="cprpTarget" >
                        <option v-for="(target_obj, target) in targetList" :value="target_obj.target_value">{{target_obj.target_NM}}</option>
                    </select>
                  </div>
                </b-col>
              </b-row>
              <b-row class="my-1" style="padding-top:10px;">
                <b-col sm="12" >
                  <span class="wise-small-header2" style="color:#20a8d8"><b>CPM</b> </span>
                  <span style="color:#20a8d8"><b>{{cprpCPM | numeral('0,0')}}</b></span>
                </b-col>
              </b-row>
            </div>
          </div>
          <hr>
          <div class="aside-options">
            <div class="clearfix mt-4" style="padding-bottom:10px;">
              <b>CPC → CPM 변환</b>
            </div>
            <div>
              <b-row>
                <b-col sm="5" style="padding-right: 0px;">
                  <span class="wise-small-header wise-small-header2">CPC</span>
                  <b-form-input style="background:#fff;" min=0 v-model="cpcStr" :formatter="format_cpcStr" type="text"></b-form-input>
                </b-col>
                <b-col sm="7">
                  <span class="wise-small-header wise-small-header2">CTR ( % )</span>
                  <b-form-input style="background:#fff;" min=0 v-model="ctr" type="number" step="0.01" ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1" style="padding-top:10px;">
                <b-col sm="12" >
                  <span class="wise-small-header2" style="color:#20a8d8"><b>CPM</b> </span>
                  <span style="color:#20a8d8"><b>{{cpcCPM | numeral('0,0')}}</b></span>
                </b-col>
              </b-row>
            </div>
          </div>
          <hr>
          <div class="aside-options">
            <div class="clearfix mt-4" style="padding-bottom:10px;">
              <b>CPV → CPM 변환</b>
            </div>
            <div>
              <b-row>
                <b-col sm="5" style="padding-right: 0px;">
                  <span class="wise-small-header wise-small-header2">CPV</span>
                  <b-form-input style="background:#fff;" min=0 v-model="cpvStr"  :formatter="format_cpvStr" type="text"></b-form-input>
                </b-col>
                <b-col sm="7">
                  <span class="wise-small-header wise-small-header2">VTR ( % )</span>
                  <b-form-input style="background:#fff;" min=0 v-model="vtr" type="number" step="0.01" ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1" style="padding-top:10px;">
                <b-col sm="12" >
                  <span class="wise-small-header2" style="color:#20a8d8"><b>CPM</b> </span>
                  <span style="color:#20a8d8"><b>{{cpvCPM | numeral('0,0')}}</b></span>
                </b-col>
              </b-row>
            </div>
          </div>
          <hr>
        </div>
      </b-tab>
      <!-- /////////////////////////////////////////////////////////////////////////////////////// -->
      <b-tab title="<i class='icon-settings'></i>">
        <Callout class="m-0 py-2 text-muted text-center bg-light text-uppercase">
          <small style="padding-right:10px;"><b>Custom Model</b></small>
            <b-button type="submit" size="sm" variant="outline-primary"
            style="background:white;min-width:20px;height:20px;padding:0 0;"
            @click="refreshModel">
              <i class="fa fa-refresh fa-sm" style="color:#20a8d8"></i>
            </b-button>
        </Callout>
        <hr class="transparent mx-3 my-0">
        <div v-for="model in modelDataList">
          <div class="animated fadeIn">
            <Callout variant="outline-primary" class="m-0 py-3">
              <div v-on:click="openModal(model)">
                <small><b>{{model.media_type}} / {{model.media}} / {{model.channel}} / {{model.target}}</b></small>
                <br>
                <small><b>모델명 : {{model.vehicle}}</b></small>
              </div>
              <div style="padding-top:5px;">
                <small>&nbsp;&nbsp;{{model.std_dt}}&nbsp;&nbsp;</small>
                <span class="float-right">
                  <!-- <b-button type="submit" size="sm" variant="outline-danger btn-pill" @click="deleteBookMark(historyData)">
                    <i class="fa fa-times-circle fa-sm"></i>
                  </b-button> -->
                  <b-button type="submit" size="sm" variant="light" style="background-color:transparent" class="btn-pill" @click="deleteModel(model)">
                    <span style="font-size:12px;font-weight:900;">X</span>
                  </b-button>
                </span>
              </div>
            </Callout>
            <hr class="mx-3 my-0">
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <b-modal title="사용자 모델 기본정보" size="lg" v-model="modelModal" @ok="modelModal = false">
      <modelCustomModal v-bind:model="selectedModel"></modelCustomModal>
    </b-modal>
  </aside>
</template>

<script>
import swal from 'sweetalert2'
import Callout from './Callout'
import cSwitch from './Switch'
import HistoryModule from './history'
import select2 from "select2/dist/js/select2.full.min.js";
import numeral from 'numeral';
import modelCustomModal from '../views/modelCustom/ModelCustomModal';
export default {
  name: 'c-aside',
  components: {
    Callout,
    cSwitch,
    HistoryModule,
    modelCustomModal
  },
  data(){
    return{
      formDataList:[],
      modelDataList:[],
      componentsHistoryList: [],
      //////////////////////////////////////
      cprp:0,
      cprpStr:0,
      cprpTarget:38900619,
      cprpCPM:0,
      //////////////////////////////////////
      //////////////////////////////////////
      cpc:0,
      cpcStr:0,
      ctr:0.30,
      cpcCPM:0,
      //////////////////////////////////////
      //////////////////////////////////////
      cpv:0,
      cpvStr:0,
      vtr:0.30,
      cpvCPM:0,
      //////////////////////////////////////
      modelModal:false,
      selectedModel:null,
      //////////////////////////////////////
      targetList:[
        {target_NM:'남녀7~69',  target_value:38900619},
        {target_NM:'남녀13~29', target_value:8893835},
        {target_NM:'남녀13~39', target_value:16503107},
        {target_NM:'남녀19~29', target_value:6013474},
        {target_NM:'남녀19~34', target_value:9324768},
        {target_NM:'남녀19~39', target_value:13622746},
        {target_NM:'남녀19~49', target_value:23278119},
        {target_NM:'남녀19~69', target_value:34568137},
        {target_NM:'남녀25~34', target_value:6159245},
        {target_NM:'남녀25~44', target_value:15141335},
        {target_NM:'남녀30~39', target_value:7609272},
        {target_NM:'남녀30~49', target_value:17264644},
        {target_NM:'남녀30~59', target_value:25067434},
        {target_NM:'남녀30~69', target_value:28554664},
        {target_NM:'남녀35~44', target_value:8982090},
        {target_NM:'남녀40~49', target_value:9655372},
        {target_NM:'남녀40~59', target_value:17458162},
        {target_NM:'남녀40~69', target_value:20945391},
        {target_NM:'남녀50~59', target_value:7802790},
        {target_NM:'남녀60~69', target_value:3487229},

        {target_NM:'남7~69',  target_value:21196359},
        {target_NM:'남13~29', target_value:5057960},
        {target_NM:'남13~39', target_value:9137949},
        {target_NM:'남19~29', target_value:3474246},
        {target_NM:'남19~34', target_value:5284668},
        {target_NM:'남19~39', target_value:7554235},
        {target_NM:'남19~49', target_value:12502057},
        {target_NM:'남19~69', target_value:18949260},
        {target_NM:'남25~34', target_value:3554025},
        {target_NM:'남25~44', target_value:8172298},
        {target_NM:'남30~39', target_value:4079989},
        {target_NM:'남30~49', target_value:9027812},
        {target_NM:'남30~59', target_value:13357934},
        {target_NM:'남30~69', target_value:15475015},
        {target_NM:'남35~44', target_value:4618273},
        {target_NM:'남40~49', target_value:4947822},
        {target_NM:'남40~59', target_value:9277945},
        {target_NM:'남40~69', target_value:11395025},
        {target_NM:'남50~59', target_value:4330123},
        {target_NM:'남60~69', target_value:2117081},

        {target_NM:'여7~69',  target_value:17704260},
        {target_NM:'여13~29', target_value:3835875},
        {target_NM:'여13~39', target_value:7365158},
        {target_NM:'여19~29', target_value:2539229},
        {target_NM:'여19~34', target_value:4040100},
        {target_NM:'여19~39', target_value:6068512},
        {target_NM:'여19~49', target_value:10776062},
        {target_NM:'여19~69', target_value:15618877},
        {target_NM:'여25~34', target_value:2605220},
        {target_NM:'여25~44', target_value:6969036},
        {target_NM:'여30~39', target_value:3529283},
        {target_NM:'여30~49', target_value:8236833},
        {target_NM:'여30~59', target_value:11709500},
        {target_NM:'여30~69', target_value:13079649},
        {target_NM:'여35~44', target_value:4363817},
        {target_NM:'여40~49', target_value:4707550},
        {target_NM:'여40~59', target_value:8180217},
        {target_NM:'여40~69', target_value:9550365},
        {target_NM:'여50~59', target_value:3472667},
        {target_NM:'여60~69', target_value:1370149},
      ]
    }
  },
  mounted:function(){
    this.loadHistory();
    this.loadModel();
    var self = this;

    setInterval(function(){
      var bookMarkReload = sessionStorage.getItem("bookMarkReload");
      if(bookMarkReload == 'insert'){
        self.loadHistory();
      }
    }, 2000);

    setInterval(function(){
      var modelReload = sessionStorage.getItem("modelReload");
      if(modelReload == 'insert'){
        self.loadModel();
      }
    }, 2000);

    this.createSelectFn(this);
  },
  watch: {
    'cprpTarget': function() {
      this.calcCPRPcpm();
    },
    'cprp': function() {
      this.calcCPRPcpm();
    },
    'ctr': function() {
      this.calcCPCcpm();
    },
    'cpc': function() {
      this.calcCPCcpm();
    },
    'vtr': function() {
      this.calcCPVcpm();
    },
    'cpv': function() {
      this.calcCPVcpm();
    }
  },
  methods:{
    format_cprpStr(value){
      var tmpVal = value.replace(/[($)\s\._\-]+/g, '');
      this.cprp = numeral(tmpVal).format('0');
      return numeral(tmpVal).format('0,0');
    },
    format_cpcStr(value){
      var tmpVal = value.replace(/[($)\s\._\-]+/g, '');
      this.cpc = numeral(tmpVal).format('0');
      return numeral(tmpVal).format('0,0');
    },
    format_cpvStr(value){
      var tmpVal = value.replace(/[($)\s\._\-]+/g, '');
      this.cpv = numeral(tmpVal).format('0');
      return numeral(tmpVal).format('0,0');
    },
    deleteBookMark(histroyData){
      // console.log('삭제로직실행');
      // console.log(histroyData);
      var self = this;
      swal({
        title: '즐겨찾기 삭제!',
        text: "선택하신 즐겨찾기를 삭제하시겠습니까?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          var token = sessionStorage.getItem("myToken");
          var user_id = histroyData.user_id;
          var id = histroyData.id;
          self.$http.get('/api/select/deleteHistory?access_token='+token+'&user_id='+user_id+'&id='+id)
            .then((result) => {
              self.refreshBookMark();
              swal({
                // position: 'top-end',
                type: 'success',
                title: '믹스안을 삭제하였습니다.',
                showConfirmButton: false,
                timer: 1500
              })
          })
        }
      })
      // var token = sessionStorage.getItem("myToken");
      // var user_id = histroyData.user_id;
      // var id = histroyData.id;
      // this.$http.get('/api/select/deleteHistory?access_token='+token+'&user_id='+user_id+'&id='+id)
      //   .then((result) => {
      //     this.refreshBookMark();
      // })
    },
    deleteModel(model){
      console.log(model);
      var self = this;
      swal({
        title: '사용자 모델 삭제!',
        text: "선택하신 모델을 삭제하시겠습니까?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {

          var token = sessionStorage.getItem("myToken");
          var param = JSON.stringify(model);
          var data = new FormData();
          data.append('objs', param);

          var config = {
            onUploadProgress: function(progressEvent) {
              var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
            }
          };

          this.$http.post('/api/delete/deleteModel?access_token='+token, data,config)
            .then((result) => {
              console.log(result.data);
              self.refreshModel();
              if(result.data.msg == 'ok'){
                swal({
                  // position: 'top-end',
                  type: 'success',
                  title: '사용자 모델을 삭제하였습니다.',
                  showConfirmButton: false,
                  timer: 6000
                })
              }else{
                swal({
                  // position: 'top-end',
                  type: 'error',
                  title: result.data.msg,
                  showConfirmButton: false,
                  timer: 1500
                })
              }

          })
        }
      })
    },
    refreshBookMark(){
      this.loadHistory();
    },
    refreshModel(){
      this.loadModel();
    },
    calcCPRPcpm(){
      this.cprpCPM = this.cprp/(this.cprpTarget/100)*1000;
    },
    calcCPCcpm(){
      this.cpcCPM = 1000*(this.ctr/100)*this.cpc;
    },
    calcCPVcpm(){
      this.cpvCPM = 1000*(this.vtr/100)*this.cpv;
    },
    loadHistory(){
        this.formDataList = [];
        var token = sessionStorage.getItem("myToken");
        var param = this.$session.get('email');
        this.$http.get('/api/select/history?access_token='+token+'&user_id='+param)
          .then((result) => {
            // console.log('success load history');
            // console.log(result.data);
            for(var i=0; i<result.data.length; i++){
              result.data[i].formData = JSON.parse(result.data[i].formData);
              // console.log(result.data[i].formData);
              this.formDataList.push(result.data[i]);
            }

            sessionStorage.setItem("bookMarkReload", "complete");
        })
    },
    loadModel(){
      this.modelDataList = [];
      var token = sessionStorage.getItem("myToken");
      var param = this.$session.get('email');
      this.$http.get('/api/select/model?access_token='+token+'&user_id='+param)
        .then((result) => {
          for(var i=0; i<result.data.length; i++){
            this.modelDataList.push(result.data[i]);
          }
          sessionStorage.setItem("modelReload", "complete");
      })
    },
    createSelectFn(vm) {
      $("#cprpTarget").select2({
        theme: "bootstrap",
      }).on('change', function() {
        if(this.value !== ''){
          vm.$data.cprpTarget = JSON.parse(this.value);
        }
      });
    }, // end createSelectFn
    gotoForm(historyData){
      // console.log('hello');
      // console.log(historyData);
      this.$session.set('historyData', historyData);
      this.$router.push("/loading/loading")
      // if(historyData.view_cd === 'reachSimulation'){
      //   console.log('reachSimulation');
      //   this.$session.set('inputFormData', historyData.formData);
      //   // this.$session.set('nexURL', '/reach/reach');
      //   window.location.href = "#/reach/reach";
      //   this.$router.push("/reach/reach")
      //   location.reload();
      //   // this.$router.go({
      //   //     path: '#/reach/reach',
      //   //     force: true
      //   //   })
      // }else if(historyData.view_cd === 'budgetAllocation'){
      //   console.log('budgetAllocation');
      //   this.$session.set('budgetFormData', historyData.formData);
      //   // this.$session.set('nexURL', '/budget/budget');
      //   // window.location.href = "#/budget/budget";
      //   this.$router.push("/budget/budget")
      // }
      //location.replace("#/reach/reach");
      // this.$router.push("/loding/loding")
      // this.$router.push("/reach/reach")
      // this.$router.go({
      //     path: '#/reach/reach',
      //     force: true
      //   })
      // location.reload();
    },
    openModal(model){
      this.selectedModel = model;
      this.modelModal = true;
    }
  }
}
</script>

<style src="select2/dist/css/select2.min.css"></style>
<style src="select2-bootstrap-theme/dist/select2-bootstrap.min.css"></style>



// WEBPACK FOOTER //
// src/components/Aside.vue